import { Box, Text } from '@betterment/samba-react';

type Props = { title: string; value: string; subtitle?: string };

export const ProjectionHighlight: React.FC<Props> = ({ title, value, subtitle }) => {
  return (
    <Box css={{ display: 'flex', gap: 'space.100' }}>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <Text variant="text50">{title}</Text>
        <Text variant="text300" css={{ smDown: { fontSize: 'fontSize.200' } }}>
          {value}
        </Text>
        {subtitle && (
          <Text variant="text50" color="text.weak">
            {subtitle}
          </Text>
        )}
      </Box>
    </Box>
  );
};
